import { useTextes } from '@common/config';
import {z} from "zod";

const t = useTextes('Commun', 'Formulaire');

export const Z_NB_RNCP = z
  .coerce.string()
  .min(1, t['DETAIL_OFA_INFO_MODIF_MSG9'])
  .pipe(z.coerce.number({ error: t['DETAIL_OFA_INFO_MODIF_MSG9']}).int())

export const NB_RNCP_PLACEHOLDER = '5';